import React from 'react';

export function Checkbox({ checked, defaultChecked, onChange, disabled = false, label, style, ...rest }) {
  const isControlled = checked !== undefined;
  const [internal, setInternal] = React.useState(!!defaultChecked);
  const on = isControlled ? checked : internal;
  const toggle = () => {
    if (disabled) return;
    if (!isControlled) setInternal(v => !v);
    onChange && onChange(!on);
  };
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--sp-3)', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1, fontFamily: 'var(--font-body)', fontSize: 'var(--fs-body)', color: 'var(--text-body)', ...style }}>
      <button
        type="button" role="checkbox" aria-checked={on} disabled={disabled} onClick={toggle}
        style={{
          width: 20, height: 20, flex: '0 0 auto', borderRadius: 'var(--radius-xs)',
          border: on ? '1.5px solid var(--accent-primary)' : '1.5px solid var(--border-strong)',
          background: on ? 'var(--accent-primary)' : 'var(--bg-surface)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer', transition: 'all var(--dur) var(--ease-out)', padding: 0,
        }}
        {...rest}
      >
        {on && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>}
      </button>
      {label}
    </label>
  );
}
